module.exports = __webpack_public_path__ + "img/ics_o_sync.2383b9d3.svg";